"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSafeState = exports.useIsMounted = exports.useUpdate = exports.useValue = exports.useRefs = exports.useFocused = exports.useAnimationCls = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var ConfigProvider_1 = require("../ConfigProvider");
var _1 = require(".");
// 使用 shared.less 里面的动画样式
function useAnimationCls() {
    var spinCls = ConfigProvider_1.usePrefix('spin');
    return { spinCls: spinCls };
}
exports.useAnimationCls = useAnimationCls;
/** 管理 focus 状态 */
function useFocused(extraHandlers, initialValue) {
    if (initialValue === void 0) { initialValue = false; }
    var _a = extraHandlers || {}, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var _b = react_1.useState(initialValue), focused = _b[0], setFocused = _b[1];
    var handleFocus = react_1.useCallback(function (e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    }, [onFocus]);
    var handleBlur = react_1.useCallback(function (e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, [onBlur]);
    var focusedHandlers = react_1.useMemo(function () { return ({ onFocus: handleFocus, onBlur: handleBlur }); }, [handleFocus, handleBlur]);
    return { focused: focused, focusedHandlers: focusedHandlers };
}
exports.useFocused = useFocused;
/** 将多个 ref 合并成一个 */
function useRefs() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    var mergedRef = react_1.useCallback(function (value) {
        refs.forEach(function (ref) {
            if (ref != null) {
                _1.fillRef(ref, value);
            }
        });
    }, refs); // eslint-disable-line react-hooks/exhaustive-deps
    return mergedRef;
}
exports.useRefs = useRefs;
/** 支持受控或不受控输入的 value 逻辑 */
function useValue(_a) {
    var valueFromProps = _a.valueFromProps, defaultValue = _a.defaultValue, onChange = _a.onChange;
    var initialValue = valueFromProps !== undefined ? valueFromProps : defaultValue;
    var _b = react_1.useState(initialValue), innerValue = _b[0], setInnerValue = _b[1];
    var value = valueFromProps !== undefined ? valueFromProps : innerValue;
    var setValue = react_1.useCallback(function (v) {
        var restV = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            restV[_i - 1] = arguments[_i];
        }
        setInnerValue(v);
        onChange === null || onChange === void 0 ? void 0 : onChange.apply(void 0, tslib_1.__spreadArrays([v], restV));
    }, [onChange]);
    return { value: value, setValue: setValue };
}
exports.useValue = useValue;
// 第一次加载不触发，之后的每次 rerender 都触发
function useUpdate(effect, deps) {
    var didMountRef = react_1.useRef(false);
    react_1.useEffect(function () {
        if (didMountRef.current === false) {
            didMountRef.current = true;
            return;
        }
        return effect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
exports.useUpdate = useUpdate;
/** 获取当前组件实例是否存活（是否 mounted）的信息 */
function useIsMounted() {
    var isMountedRef = react_1.useRef(false);
    react_1.useEffect(function () {
        isMountedRef.current = true;
        return function () {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
exports.useIsMounted = useIsMounted;
/**
 * 更安全的 useState，防止组件 unmount 后仍然被 setState 导致报错
 * > 使用此方法只能 suppress 错误信息，潜在的内存泄漏问题仍无法避免，需要确定用法后使用
 */
function useSafeState(initial) {
    var isMountedRef = useIsMounted();
    var _a = react_1.useState(initial), state = _a[0], setState = _a[1];
    var setSafeState = react_1.useCallback(function (nextState) {
        if (isMountedRef.current) {
            setState(nextState);
        }
    }, [isMountedRef]);
    return [state, setSafeState];
}
exports.useSafeState = useSafeState;
//# sourceMappingURL=hooks.js.map